import axios from 'axios';

export default function addLineItems(siteId, orderNumber, configurationGuids) {
  const url = `${window.location.origin}/api/ordering/addlineitems?siteId=${siteId}&orderNumber=${orderNumber}`;

  return axios.put(url, configurationGuids);
}
